/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Settings_Keep_AwakeInputs */

const en_us2_workout_logging_settings_keep_awake = /** @type {(inputs: Workout_Logging_Settings_Keep_AwakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the screen on during a workout`)
};

const pt_br2_workout_logging_settings_keep_awake = /** @type {(inputs: Workout_Logging_Settings_Keep_AwakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter a tela ligada no treino`)
};

const es_419_workout_logging_settings_keep_awake = /** @type {(inputs: Workout_Logging_Settings_Keep_AwakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantener la pantalla encendida al entrenar`)
};

const pt_pt2_workout_logging_settings_keep_awake = /** @type {(inputs: Workout_Logging_Settings_Keep_AwakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter o ecrã ligado durante o treino`)
};

const fr_fr2_workout_logging_settings_keep_awake = /** @type {(inputs: Workout_Logging_Settings_Keep_AwakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garder l'écran allumé pendant la séance`)
};

const de_de2_workout_logging_settings_keep_awake = /** @type {(inputs: Workout_Logging_Settings_Keep_AwakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildschirm im Training anlassen`)
};

const it_it2_workout_logging_settings_keep_awake = /** @type {(inputs: Workout_Logging_Settings_Keep_AwakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schermo sempre acceso durante l'allenamento`)
};

/**
* | output |
* | --- |
* | "Keep the screen on during a workout" |
*
* @param {Workout_Logging_Settings_Keep_AwakeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_settings_keep_awake = /** @type {((inputs?: Workout_Logging_Settings_Keep_AwakeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Settings_Keep_AwakeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_settings_keep_awake(inputs)
	if (locale === "es-419") return es_419_workout_logging_settings_keep_awake(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_settings_keep_awake(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_settings_keep_awake(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_settings_keep_awake(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_settings_keep_awake(inputs)
	return en_us2_workout_logging_settings_keep_awake(inputs)
});
export { workout_logging_settings_keep_awake as "workout-logging.settings_keep_awake" }